import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Link } from '@mui/material';
import { Download } from '@mui/icons-material';
import Date from 'components/formaters/Date';
import { InvoiceSimpleModel, InvoiceStatus } from 'models/InvoiceModel';


type InvoiceProps = {
    invoice: InvoiceSimpleModel
}

export const InvoiceLink = ({invoice}: InvoiceProps) => {
    return (
        <Link
            href={`/invoice/${invoice.id}`}
        >
            {invoice.number}
        </Link>
    );
};

export const InvoiceRenderLink = ({invoice}: InvoiceProps) => {
    return (
        <Link
            component="a"
            target="_blank"
            href={`${process.env.REACT_APP_API_HOST}/invoices/${invoice.uuid}`}
        >
            <IconButton>
                <Download/>
            </IconButton>
        </Link>
    );
};

export const InvoiceDate = ({invoice}: InvoiceProps) => {
    const {t} = useTranslation();

    if (invoice.status === InvoiceStatus.Unpaid)
        return <>{t('due_date')}: <Date date={invoice.dueDate}/></>;

    return <>{t('paid_at')}: <Date date={invoice.paidAt}/></>;
}
